import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'


Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)

// 遍历./modules目录下的js文件，并引入到modules下，相当于将原本的手动import改为自动import,无需添加一个modules就要手动再添加一个
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  //'./app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

// 所有模块，注册才能使用  modules中包含所有的state,mutations,actions
const store = new Vuex.Store({
  modules,
  getters
})

export default store
